import { Icon, Message } from 'semantic-ui-react';
import { StepperContainer, Stepper, Step } from '../weddingRequest-styles';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const StatusMessage = styled(Message)`
  margin-top: 30px !important;
  max-width: 600px;
  margin-left: auto !important;
  margin-right: auto !important;

  @media (max-width: ${screenSizes.tablet}) {
    margin: 20px 10px !important;
  }
`;

const StepProcessing = (props) => {
  const { weddingRequestProcess } = props;

  const steps = [
    {
      label: 'Solicitud recibida',
      completed: !!weddingRequestProcess?.id,
      icon: 'check circle',
    },
    {
      label: 'Verificación de Líderes',
      completed:
        weddingRequestProcess?.maleLeaderApproved === 'Aprobado' &&
        weddingRequestProcess?.femaleLeaderApproved === 'Aprobado',
      icon: 'users',
    },
    {
      label: 'Verificación de Facilitador',
      completed: !!weddingRequestProcess?.facilitatorObservations?.approved,
      icon: 'clipboard check',
    },
    {
      label: 'Asignación de Pastor',
      completed: !!weddingRequestProcess?.pastor_guest_id,
      icon: 'user circle',
    },
  ];

  const getCurrentStep = () => {
    return steps.findIndex((step) => !step.completed);
  };

  const currentStep = getCurrentStep();
  const isComplete = currentStep === -1;

  return (
    <StepperContainer>
      <p>Tu solicitud de matrimonio está en proceso:</p>
      <Stepper>
        {steps.map((step, index) => (
          <Step
            completed={step.completed}
            key={index}
            className={index === currentStep ? 'current-step' : ''}
          >
            <div className="circle-container">
              <div className="circle">
                {step.completed ? (
                  <Icon name="check" className="icon" />
                ) : (
                  <Icon name={step.icon} className="icon" />
                )}
              </div>
              {index < steps.length - 1 && <div className="line" />}
            </div>
            <div className="label">{step.label}</div>
          </Step>
        ))}
      </Stepper>

      <StatusMessage info>
        <Message.Header>
          <Icon name="info circle" /> Estado Actual
        </Message.Header>
        <p>
          {isComplete
            ? '¡Felicidades! Tu solicitud ha sido completada exitosamente.'
            : `Actualmente en proceso: ${steps[currentStep]?.label}`}
        </p>
      </StatusMessage>
    </StepperContainer>
  );
};

export default StepProcessing;
